"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Fade = _interopRequireDefault(require("reactstrap/lib/Fade"));

var _utils = require("../lib/utils");

var _toastContainer = _interopRequireDefault(require("./toastContainer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Toast = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Toast, _Component);

  var _super = _createSuper(Toast);

  function Toast(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Toast);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onAlertClose", function (alert, timer) {
      var onClose = _this.props.onClose;
      clearTimeout(timer);
      delete _this.timers[timer];

      if ((0, _utils.isFunction)(onClose)) {
        onClose(alert);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTimer", function (alert) {
      // eslint-disable-next-line no-restricted-syntax
      for (var timer in _this.timers) {
        if (_this.timers[timer] === alert) {
          return timer;
        }
      }

      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "registerTimer", function (alert) {
      var delay = _this.props.delay;
      /*
        render() will call this method multiple times,
        so if a timer is already registered for an alert
        then a new timer should not be registered for the same alert
        instead we should use the existing.
        Otherwise go ahead and create a new timer.
      */

      var prevTimer = _this.getTimer(alert);

      if (prevTimer) {
        return prevTimer;
      }

      var timer = (0, _setTimeout2["default"])(function () {
        _this.onAlertClose(alert, timer);
      }, delay);
      _this.timers[timer] = alert;
      return timer;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearAllTimers", function () {
      // eslint-disable-next-line guard-for-in
      for (var timer in _this.timers) {
        clearTimeout(timer);
      }

      _this.timers = {};
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getAlertCode", function (alert, index) {
      var timer = _this.registerTimer(alert);

      return /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
        "in": true,
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-alert oui-alert-".concat(alert.type, " oui-alert-dismissible oui-fade oui-show"),
        role: "alert"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "oui-close",
        "aria-label": "Close",
        onClick: function onClick() {
          _this.onAlertClose(alert, timer);
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")), alert.message));
    });
    _this.timers = {};
    return _this;
  }

  (0, _createClass2["default"])(Toast, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearAllTimers();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataTestId = _this$props.dataTestId,
          alerts = _this$props.alerts;
      return /*#__PURE__*/_react["default"].createElement(_toastContainer["default"], {
        dataTestId: dataTestId,
        className: (0, _utils.gatherClasses)(this.props)
      }, (0, _map["default"])(alerts).call(alerts, function (alert, index) {
        return _this2.getAlertCode(alert, index);
      }));
    }
  }]);
  return Toast;
}(_react.Component);

Toast.propTypes = {
  delay: _propTypes["default"].number,
  alerts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    message: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]).isRequired,
    type: _propTypes["default"].oneOf(["success", "warning", "danger", "info"])
  })).isRequired,
  onClose: _propTypes["default"].func.isRequired,
  dataTestId: _propTypes["default"].string
};
Toast.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  alerts: [],
  delay: 5000,
  dataTestId: "orion-toast"
};
Toast.displayName = "OrionToast";
var _default = Toast;
exports["default"] = _default;